<ng-container [formGroup]="metadataFormGroup">
  <div class="row mb-3">
    <div class="col">
      <label i18n>Nombre de pièces</label>
      <input
        class="form-control"
        type="number"
        min="0"
        step="0.5"
        formControlName="roomCount"
      />
    </div>
  </div>
  <div class="row row-cols-md-2 my-3">
    <div class="col">
      <label i18n>Type de logement</label>
      <select class="form-control" formControlName="buildingType">
        <option *ngFor="let value of buildingTypeValues" [ngValue]="value">
          {{ getBuildingTypeLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Description</label>
      <input
        class="form-control"
        type="text"
        formControlName="buildingTypeDescription"
      />
    </div>
  </div>
  <ng-container
    *ngIf="
      metadataFormGroup.value.buildingType === BuildingType.APPARTMENT_COMPLEX
    "
  >
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Utilisation (PFE...)</label>
        <input type="text" class="form-control" formControlName="use" />
      </div>
      <div class="col">
        <label i18n>Nombre d'appartements</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="noOfApartment"
        />
      </div>
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Nombre d'étages</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="noOfTrade"
        />
      </div>
      <div class="col">
        <label i18n>Zone commerciale en m²</label>
        <input
          type="number"
          min="0"
          class="form-control"
          step="0.5"
          formControlName="commercialArea"
        />
      </div>
    </div>
  </ng-container>
  <div class="row row-cols-md-2 my-3">
    <div class="col">
      <label i18n>Année de construction</label>
      <input
        type="number"
        class="form-control"
        min="0"
        formControlName="yearOfConstruction"
      />
    </div>
    <div class="col">
      <label i18n>Somme d'assurance</label>
      <input
        class="form-control"
        type="number"
        min="0"
        formControlName="sumInsured"
      />
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Adresse</label>
      <input
        class="form-control"
        type="text"
        formControlName="buildingAddress"
      />
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Mesure de sécurité</label>
      <select class="form-control" formControlName="securityMeasures">
        <option *ngFor="let value of securityMeasureValues" [ngValue]="value">
          {{ getSecurityMeasureLabel(value) }}
        </option>
      </select>
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Système de chauffage</label>
      <select class="form-control" formControlName="heatingSystem">
        <option *ngFor="let value of heatingSystemValues" [ngValue]="value">
          {{ getHeatingsSystemLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Description</label>
      <input
        type="text"
        class="form-control"
        formControlName="heatingSystemDescriptions"
      />
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Genre de construction</label>
      <select class="form-control" formControlName="typeOfConstruction">
        <option *ngFor="let value of constructionTypeValues" [ngValue]="value">
          {{ getConstructionTypeLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Type de toit</label>
      <select class="form-control" formControlName="typeOfRoof">
        <option *ngFor="let value of roofTypeValues" [ngValue]="value">
          {{ getRoofTypeLabel(value) }}
        </option>
      </select>
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Couvertures</label>
      <mat-form-field class="lty-input">
        <mat-select
          [formControl]="getControl(metadataFormGroup.controls['benefits'])"
          multiple
        >
          <mat-option
            *ngFor="let value of buildingCoverageValues"
            [value]="value"
            >{{ getBuildingCoverageLabel(value) }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Montant à assurer RC bâtiment</label>
      <input class="form-control" type="number" min="0" formControlName="sum" />
    </div>
    <div class="col">
      <label i18n>Franchise</label>
      <input
        class="form-control"
        type="number"
        min="0"
        formControlName="franchise"
      />
    </div>
  </div>
  <div class="mt-4">
    <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
      Questionnaire
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1">
      <div class="col">
        <label i18n
          >Est-il ou a-t-il été assuré pour les branches proposées ?</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="pastInsured"
            id="pastInsuredFalse"
            [value]="false"
            formControlName="pastInsured"
          />
          <label class="form-check-label" for="pastInsuredFalse"> Non </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="pastInsured"
            id="pastInsuredTrue"
            [value]="true"
            formControlName="pastInsured"
          />
          <label class="form-check-label" for="pastInsuredTrue"> Oui </label>
        </div>
      </div>

      <div class="col" *ngIf="metadataFormGroup.value.pastInsured === true">
        <label i18n>Compagnie et n° de police</label>
        <input type="text" class="form-control" formControlName="companyName" />
      </div>
      <div class="col" *ngIf="metadataFormGroup.value.pastInsured === false">
        <label i18n>Raison de cette conclusion</label>
        <input type="text" class="form-control" formControlName="reason" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label i18n
          >A-t-il u des cas de sinistre pour les risques à assurer ?</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="anyClaims"
            id="anyClaimsFalse"
            [value]="false"
            formControlName="anyClaims"
          />
          <label class="form-check-label" for="anyClaimsFalse"> Non </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="anyClaims"
            id="anyClaimsTrue"
            [value]="true"
            formControlName="anyClaims"
          />
          <label class="form-check-label" for="anyClaimsTrue"> Oui </label>
        </div>
      </div>
    </div>
    <ng-container *ngIf="metadataFormGroup.value.anyClaims">
      <div
        class="claim-row mb-3"
        formArrayName="claimDetails"
        *ngFor="let control of claims.controls; let i = index"
      >
        <button
          class="remove-claim-btn"
          (click)="removeRow(i)"
          *ngIf="canRemoveRow"
        >
          X
        </button>
        <div class="row row-cols-1 row-cols-md-3">
          <ng-container [formGroup]="getGroup(i)">
            <div class="col">
              <label class="mb-1" i18n>Type de sinistre</label>
              <select
                class="form-control"
                type="text"
                name="type"
                formControlName="type"
              >
                <option
                  *ngFor="let claimType of getAvailableValues(i)"
                  [ngValue]="claimType"
                >
                  {{ getBuildingCoverageLabel(claimType) }}
                </option>
              </select>
            </div>

            <div class="col">
              <label class="mb-1" i18n>Nombre</label>
              <input
                class="form-control"
                type="number"
                name="count"
                formControlName="count"
              />
            </div>
            <div class="col">
              <label class="mb-1" i18n>Coût global des sinistres</label>
              <input
                class="form-control"
                type="number"
                name="cost"
                formControlName="cost"
              />
            </div>
          </ng-container>
        </div>
      </div>

      <button
        type="button"
        class="d-flex btn-light me-auto ms-auto mt-4"
        (click)="addRow()"
        [disabled]="addButtonDisabled"
      >
        <span class="plus_sign me-2">+</span>
        <span i18n>Ajouter un nouveau type de sinistre</span>
      </button>
    </ng-container>
  </div>
</ng-container>
